import getLocationRouterSelect from 'modules/router/selectors/get-location'
import { createSelector } from 'reselect'
import { getQueryParamsFromStringObjectUtil } from 'packages/src'

export const getLocationQueryParamsRouterSelect = createSelector(
  getLocationRouterSelect,
  location => {
    if (!location) {
      return {}
    }
    const search = location.search || ''
    return getQueryParamsFromStringObjectUtil(search)
  }
)
